import { useState } from "react";

export default function Gallery() {
  const images = [
    "/pictures/Church_Overview.jpg",
    "/pictures/FHC_1.jpg",
    "/pictures/FHC_2.jpg",
    "/pictures/Garden_1.jpg",
    "/pictures/Garden_2.jpg",
    "/pictures/IMG_5087.JPG",
    "/pictures/IMG_5090.JPG",
    "/pictures/IMG_5094.JPG",
    "/pictures/IMG_5097.JPG",
    "/pictures/IMG_5101.JPG",
    "/pictures/IMG_5105.JPG",
    "/pictures/IMG_5106.JPG",
    "/pictures/IMG_5107.JPG",
    "/pictures/IMG_5108.JPG",
    "/pictures/IMG_5110.JPG",
    "/pictures/IMG_5112.JPG",
    "/pictures/IMG_5117.JPG",
    "/pictures/IMG_5123.JPG",
    "/pictures/IMG_5125.JPG",
    "/pictures/IMG_5126.JPG",
    "/pictures/IMG_5131.JPG",
    "/pictures/IMG_5133.JPG",
    "/pictures/IMG_5137.JPG",
    "/pictures/IMG_5139.JPG",
    "/pictures/IMG_5140.JPG",
    "/pictures/IMG_5145.JPG",
    "/pictures/IMG_5148.JPG",
    "/pictures/IMG_5152.JPG",
    "/pictures/IMG_5153.JPG",
    "/pictures/IMG_5159.JPG",
    "/pictures/IMG_5162.JPG",
    "/pictures/IMG_5164.JPG",
    "/pictures/IMG_5168.JPG",
    "/pictures/IMG_5174.JPG",
    "/pictures/IMG_5178.JPG",
    "/pictures/IMG_5180.JPG",
    "/pictures/IMG_5181.JPG",
    "/pictures/IMG_5184.JPG",
    "/pictures/IMG_5186.JPG",
    "/pictures/IMG_5192.JPG",
    "/pictures/IMG_5193.JPG",
    "/pictures/IMG_5197.JPG",
    "/pictures/IMG_5200.JPG",
    "/pictures/IMG_5203.JPG",
    "/pictures/IMG_5205.JPG",
    "/pictures/IMG_5207.JPG",
    "/pictures/IMG_5211.JPG",
    "/pictures/IMG_5212.JPG",
    "/pictures/IMG_5214.JPG",
    "/pictures/IMG_5216.JPG",
    "/pictures/IMG_5218.JPG",
    "/pictures/IMG_5219.JPG",
    "/pictures/IMG_5224.JPG",
    "/pictures/IMG_5226.JPG",
    "/pictures/IMG_5229.JPG",
    "/pictures/IMG_5230.JPG",
    "/pictures/IMG_5234.JPG",
    "/pictures/IMG_5235.JPG",
    "/pictures/IMG_5237.JPG",
    "/pictures/IMG_5238.JPG",
    "/pictures/IMG_5241.JPG",
    "/pictures/IMG_5245.JPG",
    "/pictures/IMG_5246.JPG",
    "/pictures/IMG_5247.JPG",
    "/pictures/IMG_5248.JPG",
    "/pictures/IMG_5250.JPG",
    "/pictures/IMG_5255.JPG",
    "/pictures/IMG_5256.JPG",
    "/pictures/IMG_5257.JPG",
    "/pictures/IMG_5259.JPG",
    "/pictures/IMG_5261.JPG",
    "/pictures/IMG_5263.JPG",
    "/pictures/IMG_5265.JPG",
    "/pictures/IMG_5267.JPG",
    "/pictures/IMG_5269.JPG",
    "/pictures/IMG_5290.JPG",
    "/pictures/IMG_5294.JPG",
    "/pictures/IMG_5295.JPG",
    "/pictures/IMG_5296.JPG",
    "/pictures/IMG_5299.JPG",
    "/pictures/IMG_5309.JPG",
    "/pictures/IMG_5311.JPG",
    "/pictures/IMG_5314.JPG",
    "/pictures/IMG_5316.JPG",
    "/pictures/IMG_5321.JPG",
    "/pictures/IMG_5325.JPG",
    "/pictures/IMG_5327.JPG",
    "/pictures/IMG_5328.JPG",
    "/pictures/IMG_5330.JPG",
    "/pictures/IMG_5331.JPG",
    "/pictures/Offering.JPG",
    "/pictures/Procession.JPG",
    "/pictures/update1.jpg",
    "/pictures/update2.jpg",
    "/pictures/update3.jpg",
    "/pictures/update4.jpg",
    "/pictures/update5.jpg",
    "/pictures/image0.jpg",
    "/pictures/image1.jpg",
    "/pictures/image2.jpg"
  ];

  const [isOpen, setIsOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const openLightbox = (index) => {
    setCurrentIndex(index);
    setIsOpen(true);
  };

  const closeLightbox = () => setIsOpen(false);

  const prevImage = () => {
    setCurrentIndex((currentIndex - 1 + images.length) % images.length);
  };

  const nextImage = () => {
    setCurrentIndex((currentIndex + 1) % images.length);
  };

  return (
    <div className="min-h-screen bg-gray-100 py-10">
      {/* Gallery Grid */}
      <div className="max-w-6xl mx-auto px-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {images.map((src, index) => (
          <div
            key={index}
            onClick={() => openLightbox(index)}
            className="cursor-pointer overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300"
          >
            <img
              src={src}
              alt={`Gallery ${index + 1}`}
              className="w-full h-64 object-cover hover:scale-105 transition-transform duration-300"
            />
          </div>
        ))}
      </div>

      {/* Lightbox Overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50"
          onClick={closeLightbox}
        >
          <button
            onClick={(e) => {
              e.stopPropagation();
              prevImage();
            }}
            className="absolute left-5 text-white text-6xl font-bold focus:outline-none select-none"
          >
            ‹
          </button>

          <img
            src={images[currentIndex]}
            alt={`Lightbox ${currentIndex + 1}`}
            className="max-h-[80vh] max-w-[90vw] rounded-lg shadow-lg"
            onClick={(e) => e.stopPropagation()} // prevent closing on image click
          />

          <button
            onClick={(e) => {
              e.stopPropagation();
              nextImage();
            }}
            className="absolute right-5 text-white text-6xl font-bold focus:outline-none select-none"
          >
            ›
          </button>

          <button
            onClick={closeLightbox}
            className="absolute top-5 right-5 text-white text-3xl font-bold focus:outline-none"
            aria-label="Close lightbox"
          >
            ×
          </button>
        </div>
      )}
    </div>
  );
}